// extracted by mini-css-extract-plugin
export var content = "_qg-1";
export var noScroll = "_qg-3";
export var paper = "_qg-0";
export var scrollable = "_qg-2";